<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <div class="evq-spinner">
    <i class="fa-solid fa-circle-notch fa-spin"></i>
  </div>
</div>

<ng-container *ngIf="!loading">
  <div class="game">

    <!-- Bouton quitter — même niveau que app-game-close-button dans les jeux -->
    <div class="evq-nav">
      <button class="evq-quit-btn" (click)="close()">
        <i class="fa-solid fa-xmark"></i>
        <span translate>Quitter</span>
      </button>
    </div>

    <div class="game-content pb-4">
      <div class="game-content-container game-content-container-80">

        <!-- En-tête avec titre — même style que gg-header dans les jeux -->
        <div class="evq-header mb-4" translate>
          Test de positionnement
        </div>

        <!-- Instruction -->
        <div class="evq-instruction mb-4" *ngIf="item.question.instruction && !item.question.isAudio">
          {{ item.question.instruction }}
        </div>

        <!-- Audio question -->
        <div class="d-flex justify-content-center mb-4" *ngIf="item.question.isAudio">
          <div class="play-container d-flex align-items-center justify-content-center" (click)="audioSrv.play(item.question.audio)">
            <i class="fa-solid fa-volume-high"></i>
          </div>
        </div>

        <!-- Titre texte (question non-audio avec un titre) -->
        <div class="evq-question-box mb-4" *ngIf="item.question.title && !item.question.isAudio">
          <!-- Phrase à trou : le [?] devient un emplacement visuel rempli par la réponse choisie -->
          <ng-container *ngIf="gapParts.length">
            <ng-container *ngFor="let part of gapParts; let last = last; trackBy: trackByIndex">
              <span>{{ part }}</span>
              <span class="evq-gap" *ngIf="!last" [class.evq-gap--filled]="selectedAnswer?.answer">{{ selectedAnswer?.answer }}</span>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!gapParts.length">{{ item.question.title }}</ng-container>
        </div>

        <!-- Réponses -->
        <div class="evq-answers">
          <div
            class="answer"
            *ngFor="let answer of item.answers; trackBy: trackByIndex"
            (click)="selectAnswer(answer)"
            [class.answer-selected]="selectedAnswer && answer.uniqid === selectedAnswer.uniqid">
            <ng-container *ngIf="answer.answer">{{ answer.answer }}</ng-container>
            <ng-container *ngIf="answer.audio">
              <i class="fa-solid fa-volume-high"></i>
            </ng-container>
          </div>

          <div
            class="answer"
            (click)="selectedAnswer = 'unknow'"
            [class.answer-selected]="selectedAnswer === 'unknow'"
            translate>
            Je ne sais pas
          </div>
        </div>

        <!-- Bouton suivant -->
        <div class="text-center mt-4 mb-4">
          <button class="btn-suivant" (click)="next()" [disabled]="!selectedAnswer" translate>
            Question suivante
          </button>
        </div>

      </div>
    </div>

  </div>
</ng-container>
